// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class TradingSignalRequestMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_TRADING_SIGNALS_REQ_MESSAGE, fieldSet);
    }
}
